"use client";

import React, { useState } from 'react';
import { FaqItem } from '@/types/faqTypes';

interface FAQComponentProps {
    faqs: FaqItem[];
}

const FAQComponent: React.FC<FAQComponentProps> = ({ faqs }) => {
    const [openIndex, setOpenIndex] = useState<number | null>(null);

    const toggleFaq = (index: number) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <div className='w-full max-w-[90.69vw] sm:max-w-[90.80vw] lg:max-w-[76.04vw] mx-auto mt-12 sm:mt-16 lg:mt-20 mb-20'>
            <div className='grid grid-cols-1 lg:grid-cols-[30%_70%] gap-8 sm:gap-12 lg:gap-16 lg:px-web-40'>
                {/* Left side - Heading */}
                <div className='flex flex-col justify-start text-center lg:text-left'>
                    <h2
                        className="text-mob-32 sm:text-mob-32 lg:text-web-32 font-bold leading-[120%] text-PrimaryDarkBlue uppercase"
                    >
                        Detailed <br className='hidden lg:block' /> Information
                    </h2>
                    <p className="mt-4 text-[#8D8D8D] text-mob-18 lg:text-web-20">
                        Everything you need to know about our products and services.
                    </p>
                </div>

                {/* Right side - FAQ Accordion */}
                <div className='space-y-4'>
                    {faqs.map((faq, index) => (
                        <div
                            key={faq._id || index}
                            className={`rounded-lg border border-[#DBDBDB] transition-all duration-300 ${openIndex === index
                                ? 'bg-[#F9F9F9] shadow-sm'
                                : 'bg-white hover:bg-[#F5F5F5]'
                                }`}
                        >
                            <button
                                onClick={() => toggleFaq(index)}
                                className='w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none'
                            >
                                <h3
                                    className='text-mob-20 lg:text-web-22 font-medium leading-[130%] text-[#333333]'
                                >
                                    {faq.question}
                                </h3>
                                <div className='ml-4 flex-shrink-0'>
                                    <svg
                                        className={`w-6 h-6 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''
                                            } text-PrimaryLightBlue`}
                                        fill='none'
                                        stroke='currentColor'
                                        viewBox='0 0 24 24'
                                    >
                                        <path
                                            strokeLinecap='round'
                                            strokeLinejoin='round'
                                            strokeWidth={2}
                                            d='M19 9l-7 7-7-7'
                                        />
                                    </svg>
                                </div>
                            </button>
                            <div
                                className={`overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-[1000px] opacity-100' : 'max-h-0 opacity-0'
                                    }`}
                            >
                                <div className='px-6 pb-6'>
                                    <p className='text-mob-17 sm:text-mob-17 lg:text-web-18 text-[#595959] leading-[160%]'>
                                        {faq.answer}
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))}

                    {faqs.length === 0 && (
                        <div className="text-center py-10 text-[#8D8D8D]">
                            No FAQs available at the moment.
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default FAQComponent;
